import { useEffect, useRef } from "react";
import { Pagination, Autoplay, Keyboard } from "swiper";
import { Swiper, SwiperRef, SwiperSlide } from "swiper/react";
import { SwiperModule } from "swiper/types";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/keyboard";
import { Banner } from "../../model/novedades/Banner";
import { Slide } from "./Slide";

/**Milisegundos de demora entre transiciones. */
const DELAY_MILLISECONDS: number = 5000;
/**Milisegundos de duración de cada transición. */
const TRANSITION_MILLISECONDS: number = 1000;
/**Activar reproducción cíclica */
const LOOP = false;
/**Activar reproducción automática */
const AUTOPLAY = true;
const swiperModules: SwiperModule[] = [Pagination, Autoplay, Keyboard];

type CarrouselProps = {
  items: Banner[];
  fullBorderRadius: boolean | undefined;
};

export function Carrousel(props: CarrouselProps) {
  const swiperRef = useRef<SwiperRef>(null);

  useEffect(() => {
    /** Importante: necesario para que funcione autoplay */
    if (AUTOPLAY && swiperRef?.current?.swiper?.autoplay)
      swiperRef.current.swiper.autoplay.running = true;
  }, []);

  return (
    <Swiper
      modules={swiperModules}
      autoplay={{ delay: DELAY_MILLISECONDS }}
      pagination={{ clickable: true }}
      loop={LOOP}
      speed={TRANSITION_MILLISECONDS}
      slidesPerView={
        "auto"
      } /** Importante: necesario para que funcione redimensionamiento horizontal */
      ref={swiperRef}
      spaceBetween={4}
      className={
        props.fullBorderRadius
          ? "radiusWithNoCurrencyBar"
          : "radiusWithCurrencyBar"
      }
    >
      {props?.items?.map((banner: Banner, index: number) => (
        <SwiperSlide key={index}>
          <Slide
            item={banner}
            fullBorderRadius={props.fullBorderRadius}
            index={index}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
